module.exports = __webpack_public_path__ + "img/coin1.462f697.webp";